<template>
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="animate-spin"
  >
    <path
      d="M2.33648 12.1148C3.6091 13.8634 5.67182 15 8 15C11.866 15 15 11.866 15 8L16 8C16 9.68943 15.4652 11.3355 14.4721 12.7023C14.2578 12.9972 14.0246 13.2759 13.7744 13.5369C13.7591 13.5528 13.7437 13.5687 13.7283 13.5845C13.6823 13.6317 13.6357 13.6783 13.5886 13.7243C13.5694 13.7431 13.5501 13.7617 13.5307 13.7803C12.6659 14.6077 11.6219 15.2349 10.4721 15.6085C8.86539 16.1305 7.13461 16.1305 5.52786 15.6085C4.38303 15.2365 3.34303 14.6131 2.48048 13.7909C2.38786 13.7026 2.29735 13.6121 2.20905 13.5195C1.96511 13.2636 1.73742 12.9907 1.52786 12.7023L2.33648 12.1148Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts"></script>
